module.exports = {
    "All": "Tous",

    "Male": 'Homme',
    "Female": 'Femme',
    "Couple": 'Couple',
    "Transvestite": 'Travesti'
}


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/gender_select.js